"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriasCNH = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CommonSelect_1 = require("./CommonSelect");
const CategoriasCNH = (props) => ((0, jsx_runtime_1.jsx)(CommonSelect_1.CommonSelect, Object.assign({ options: [
        { value: "A", label: "A" },
        { value: "B", label: "B" },
        { value: "AB", label: "AB" },
        { value: "C", label: "C" },
        { value: "D", label: "D" },
        { value: "E", label: "E" },
    ] }, props), void 0));
exports.CategoriasCNH = CategoriasCNH;
